import { Graph } from '../../../types';

export const bumpGraph = (graph: Graph): Graph => ({
  ...graph,
  graphVersion: (graph.graphVersion ?? 0) + 1,
});

export const bumpTopology = (graph: Graph): Graph => ({
  ...graph,
  graphVersion: (graph.graphVersion ?? 0) + 1,
  topologyVersion: (graph.topologyVersion ?? 0) + 1,
});
